module.exports = __webpack_public_path__ + "img/bg-character.c43f47cd.svg";